<template>
    <img class="w-full ad-container border bg-salesium-grey-100 block br-10 mb-7" :src="image" />
</template>

<script>
export default {
    props: ['aspectRatio', 'image']
}
</script>